export const COST_CENTRES = {
    1: {
        id: 1,
        name: `111S11A`,
        description: `New job site`,
        isDeleted: true,
    },
    2: {
        id: 2,
        name: `09882841A`,
        description: `Subdivision B located near the road on the north boundary`,
        isDeleted: false,
    },
    3: {
        id: 3,
        name: `AAA`,
        description: `Accounts Accounts Accounts`,
        isDeleted: false,
    },
    4: {
        id: 4,
        name: `5055`,
        description: `Health and Safety`,
        isDeleted: false,
    },
    5: {
        id: 5,
        name: `S-1154`,
        description: `Sales Team`,
        isDeleted: false,
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/costCentres.js